<quill-view
  [content]="this.content() || ''"
  [sanitize]="this.sanitize()"
  [theme]="this.theme()"
  class="prose max-w-full overflow-hidden whitespace-pre-line break-words text-gray-600"></quill-view>
